/**
 * Module: screens/onboarding/BuyerOnboardingScreen
 * Role: Wizard root — sub-router for buyer onboarding steps (FTR-1115).
 *       Sibling to /creator-onboarding/* — no AppShell/TabBar.
 *       Route: /onboarding/* (mounted in App.tsx).
 *
 * Uses:
 *   - react-router-dom (Routes, Route, Navigate)
 *   - screens/flow/atoms/Frame (status-bar wrapper)
 *   - screens/onboarding/steps/* (WelcomeStep, CityStep, PreparingStep)
 *
 * Used by: App.tsx route /onboarding/*
 * Glossary: ai/glossary/buyer.md
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import { Frame } from '../flow/atoms/Frame';
import { WelcomeStep } from './steps/WelcomeStep';
import { CityStep } from './steps/CityStep';
import { PreparingStep } from './steps/PreparingStep';

export default function BuyerOnboardingScreen() {
  return (
    <Frame>
      <Routes>
        <Route index element={<Navigate to="welcome" replace />} />
        <Route path="welcome" element={<WelcomeStep />} />
        <Route path="city" element={<CityStep />} />
        <Route path="preparing" element={<PreparingStep />} />
      </Routes>
    </Frame>
  );
}
